export default __webpack_public_path__ + "static/media/black-felt.bb1f6180.webp";